export default "__VITE_ASSET__C0gO4WpH__"